import { Component, computed, input } from '@angular/core';
import { translate, translateObject } from '@jsverse/transloco';
import { DropdownObject } from '@inmoment/the-kitchen';

import { WidgetDataSource } from '../../../../../models';
import { Widget } from '../../../../../providers/bridge-api/dashboard.service';
import { ChartOptionUtils } from '../../../../../utils/chart-options.utils';
import { ChartDateInterval } from '../../widget-chart/widget-chart.component';
@Component({
  template: '',
})
export abstract class GridAnalyticItemConfigSectionComponent {
  timeIntervalOptions = computed<DropdownObject[]>(() => this.getTimeIntervalOptions(), {
    debugName: 'getTimeIntervalOptions',
  });
  widgetDataSource = input<WidgetDataSource>();

  widget = input<Widget>();

  protected getTimeIntervalOptions() {
    return ChartDateInterval.filter((v) => v !== 'minute' && v !== 'hour').map((scale) => {
      return {
        id: scale,
        title: this.getTimeIntervalTitle(scale),
        disabled: !this.isDateIntervalEnabled(scale),
        get subtitle() {
          return (
            (this.disabled && translate('widgets.options.not-available-for-current-data')) ||
            undefined
          );
        },
      };
    });
  }

  protected getTimeIntervalTitle(type) {
    const translations = translateObject('widgets.options.display-names');
    return translations[type] ?? type;
  }

  isDateIntervalEnabled(value, aggregator = this.widget().payload.aggregator) {
    return this.widgetDataSource().hasDateData && this.isOverTimeAggregation(aggregator);
  }

  isOverTimeAggregation(agg: string): boolean {
    return this.widget().payload.type === 'grid' || ChartOptionUtils.isOverTimeAggregator(agg);
  }
}
